import { render, staticRenderFns } from "./GCTDetail.vue?vue&type=template&id=5b310468&scoped=true"
import script from "./GCTDetail.vue?vue&type=script&lang=js"
export * from "./GCTDetail.vue?vue&type=script&lang=js"
import style0 from "./GCTDetail.vue?vue&type=style&index=0&id=5b310468&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b310468",
  null
  
)

export default component.exports